<template>
  <v-card outlined class="rounded-lg">
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="mapConfig"
        hide-default-footer
        disable-pagination
        class="elevation-0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Map Global Config</v-toolbar-title>
            <v-spacer/>
            <v-dialog v-model="dialog" max-width="700px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">New Value</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.key"
                          label="Key"
                          filled
                          v-validate="{
                            required: true
                          }"
                          name="key"
                          :error-messages="errors.collect('key')"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.value"
                          label="Value"
                          filled
                          v-validate="{
                            required: true
                          }"
                          name="value"
                          :error-messages="errors.collect('value')"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-select
                          v-model="editedItem.type"
                          :items="['string', 'number']"
                          label="Type"
                          filled
                          v-validate="{
                            required: true
                          }"
                          name="type"
                          :error-messages="errors.collect('type')"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            {{ mdiPencil }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiPencil } from '@mdi/js';
export default {
  data() {
    return {
      mdiPencil,
      dialog: false,
      headers: [
        {
          text: 'Key',
          value: 'key',
          sortable: false,
        },
        {
          text: 'Value',
          value: 'value',
          sortable: false,
        },
        {
          text: 'Type',
          value: 'type',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],
      mapConfig: [],
      editedIndex: -1,
      editedItem: {
        key: '',
        value: '',
        type: 'string',
      },
      defaultItem: {
        key: '',
        value: '',
        type: 'string',
      },
    }
  },
  async created() {
    let { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/map');
    this.mapConfig = data;
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Value' : 'Edit Value';
    },
  },
  methods: {
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    editItem (item) {
      this.editedIndex = this.mapConfig.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    save () {
      this.$validator.validateAll().then(async res => {
        if (res) {
          try {
            if (this.editedIndex > -1) {
              const { data } = await this.$axios.put(this.$store.getters.projectPath + '/configs/map/' + this.editedItem.id, this.editedItem);
              this.mapConfig.splice(this.editedIndex, 1, data);
            } else {
              const { data } = await this.$axios.post(this.$store.getters.projectPath + '/configs/map', this.editedItem);
              this.mapConfig.push(data);
            }
          } catch(err) {
            console.log(err.message);
          }
          this.close();
        }
      })
    },
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
}
</script>